import { NorthEast as NorthEastIcon, SouthEast as SouthEastIcon } from '@mui/icons-material'

import ScoutAvatar from '../../ScoutAvatar'
import GraphicsPanel from './GraphicsPanel'

const Trend = ({ trend }) => {
	if (!trend?.value) {
		return null
	}

	const isUp = trend.direction !== 'down'
	const TrendIcon = isUp ? NorthEastIcon : SouthEastIcon

	return (
		<span className={isUp ? 'scout-graphics-trend scout-graphics-trend--up' : 'scout-graphics-trend scout-graphics-trend--down'}>
			{trend.value}
			<TrendIcon fontSize="inherit" />
		</span>
	)
}

const SatisfactionChart = ({ data, empty = false }) => {
	const points = data?.points || []
	const ticks = data?.ticks || []

	return (
		<GraphicsPanel
			title="Índice de Satisfação"
			empty={empty || (!points.length && typeof data?.average !== 'number')}
			footer={
				!empty && typeof data?.average === 'number' ? (
					<div className="scout-graphics-footer-row">
						<span>Nota média do índice de satisfação: <strong>{data.averageLabel}</strong></span>
						<Trend trend={data.trend} />
					</div>
				) : null
			}
		>
			<div className="scout-graphics-chart scout-graphics-chart--satisfaction">
				<div className="scout-graphics-chart__axes scout-graphics-chart__axes--qualitative">
					{ticks.map((tick) => (
						<div key={tick.value} className="scout-graphics-axis-row scout-graphics-axis-row--labelled">
							<span style={{ color: tick.color }}>{tick.label}</span>
							<strong>{tick.displayValue}</strong>
							<div />
						</div>
					))}
				</div>
				<div className="scout-graphics-chart__plot scout-graphics-chart__plot--satisfaction">
					<div className="scout-graphics-grid-lines" aria-hidden="true">
						{ticks.map((tick) => {
							const offset = 100 - (Number(tick.value || 0) / 10) * 100

							return <span key={`line-${tick.value}`} className="scout-graphics-grid-line" style={{ top: `${offset}%` }} />
						})}
					</div>
					{points.map((point, index) => {
						const x = point.x ?? ((index + 1) / (points.length + 1)) * 100
						const y = 100 - (Number(point.value || 0) / 10) * 100

						return (
							<div
								key={point.id}
								className="scout-graphics-rating-point"
								style={{
									left: `${x}%`,
									top: `${Math.max(10, Math.min(92, y))}%`,
								}}
							>
								<ScoutAvatar
									entity={point}
									alt={point.name}
									className="scout-graphics-rating-point__avatar"
									imgStyle={{ borderColor: point.color }}
									fallback={() => (
										<div className="scout-graphics-rating-point__avatar" style={{ borderColor: point.color }}>
											{point.initials}
										</div>
									)}
								/>
								<div className="scout-graphics-rating-point__badge">{point.label}</div>
							</div>
						)
					})}
				</div>
			</div>
		</GraphicsPanel>
	)
}

export default SatisfactionChart